import { ColorOptions, convertHexToRGBA, Spacer, TextNew } from '@jfs/ui-new'
import { TextInputWithLabelOnBorder } from '../../comps/TextInputWithLabelOnBorder'
import { forgotPwdStrings } from '../../data/static/strings'
import { getString } from '../../util/languageStrings'
import { Colors, testProps } from '../../util/util'
import { mobileNumber } from '../../util/validations'

export const formData = (selectedAppLanguage: any, leftComponent?: any, passwordRef?: any): any => [
  {
    formItems: [
      {
        fieldName: 'title',
        ComponentName: TextNew,
        label: 'forgotpwd',
        title: getString(selectedAppLanguage, 'forgotPassword'),
        fontFamily: 'JioType-Black',
        fontSize: 24,
        lineHeight: 28,
        color: '#141414' as ColorOptions,
      },
      {
        fieldName: 'label',
        ComponentName: TextNew,
        label: 'forgotpwdLabel',
        title: getString(selectedAppLanguage, 'enterMobileNumberAssociated'),
        fontFamily: 'JioType-Medium',
        fontSize: 14,
        lineHeight: 20,
        maxWidth: '85%',
        letterSpacing: -0.07,
        color: convertHexToRGBA(Colors.BLACK, 65) as ColorOptions,
      },
      {
        fieldName: 'spacer3',
        ComponentName: Spacer,
        direction: 'vertical',
        size: 16,
      },
      {
        fieldName: 'mobileNumber',
        ComponentName: TextInputWithLabelOnBorder,
        label: getString(selectedAppLanguage, 'mobileNumber'),
        validationSchema: mobileNumber,
        innerRef: passwordRef,
        autoFocus: true,
        maxLength: 10,
        inputMode: 'numeric',
        returnKeyType: 'done',
        leftComponent: leftComponent,
        ...testProps('forgot-mobile-input'),
        selectionColor: Colors.PRIMARY,
      },
      {
        fieldName: 'spacer4',
        ComponentName: Spacer,
        direction: 'vertical',
        size: 0,
      },
    ],
    actionTitle: getString(selectedAppLanguage, 'continue'),
    onSubmit: () => {
      console.log('otp')
    },
  },
]
export const pwdStrengthCbData = [
  {
    id: '1',
    value: forgotPwdStrings.eightCharacters,
  },
  {
    id: '2',
    value: forgotPwdStrings.oneLowerCaseLetter,
  },
  {
    id: '3',
    value: forgotPwdStrings.oneCapitalLetter,
  },
  {
    id: '4',
    value: forgotPwdStrings.oneSpecialCharacter,
  },
  {
    id: '5',
    value: forgotPwdStrings.oneDigit,
  },
]
